import script from "./group_new.vue?vue&type=script&setup=true&lang=js"
export * from "./group_new.vue?vue&type=script&setup=true&lang=js"

import "./group_new.vue?vue&type=style&index=0&id=01705554&scoped=true&lang=scss"

import exportComponent from "/var/jenkins_home/workspace/fbdnextui_staging-uk-v3/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01705554"]])

export default __exports__